<template>
  <div id="app">
    <!-- This is where Vue Router will inject the active page -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>
